<div class="app">
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</div>
